import React, { Component } from 'react';
import DrawingLogo from 'containers/Drawings/DrawingLogo';
import TextButton from 'components/TextButton';
import { formatDate } from 'utils/formatting';
import { withDrawingCountdown } from '../../utils/withDrawingCountdown';
import './DrawingDetails.css';

class DrawingDetails extends Component {
  render() {
    const { drawing, isDesktopOrLarger } = this.props;
    const prizes =
      drawing.winningPlaces &&
      drawing.winningPlaces.winningPlaces.map(place => place.prize);

    return (
      <div className="drawing-details-container">
        <div className={`drawing-countdown`}>
          <span className="countdown-label">Drawing In:</span>
          <span className="countdown-time">{this.props.renderCountDown()}</span>
        </div>
        <div className="drawing-card">
          {isDesktopOrLarger && <DrawingLogo prizes={prizes} />}
          <div className="draw-date">
            {formatDate(drawing.drawTime, 'fullCompact')}
          </div>
          {!isDesktopOrLarger && (
            <div className="header">
              <div className="name">{drawing.name}</div>
              <div className="prize-and-description-container">
                <DrawingLogo prizes={prizes} />
                <div className="description">{drawing.description}</div>
              </div>
              <div className="eligibility">
                <TextButton onClick={this.props.handleTerms}>
                  View Eligibility
                </TextButton>
              </div>
            </div>
          )}
          {!isDesktopOrLarger &&
            drawing.drawingState === 'InProgress' &&
            this.props.renderRoundTicker()}
          {this.props.renderDrumState()}
        </div>
      </div>
    );
  }
}

export default withDrawingCountdown(DrawingDetails);
